export default __webpack_public_path__ + "public/icons/testCaseRepository.png?674ca38e6ea121537073f636bf76c054";